import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "ui-dropdown-item__content" }

import { computed } from "vue";
import { Icon } from "@iconify/vue";

interface Props {
  icon?: string;
  iconSrc?: string;
  disabled?: boolean;
  danger?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownItem',
  props: {
    icon: {},
    iconSrc: {},
    disabled: { type: Boolean, default: false },
    danger: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const itemClasses = computed(() => {
  const classes = ["ui-dropdown__item"];
  if (props.disabled) classes.push("ui-dropdown__item--disabled");
  if (props.danger) classes.push("ui-dropdown__item--danger");
  return classes;
});

const handleClick = (event: MouseEvent) => {
  if (!props.disabled) {
    emit("click", event);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(itemClasses.value),
    onClick: handleClick
  }, [
    (__props.iconSrc)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: __props.iconSrc,
          class: "ui-dropdown-item__icon"
        }, null, 8, _hoisted_1))
      : (__props.icon)
        ? (_openBlock(), _createBlock(_unref(Icon), {
            key: 1,
            icon: __props.icon,
            class: "ui-dropdown-item__icon"
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})